import { useState } from 'react';

interface HeroSectionProps {
  onCTAClick: () => void;
}

export default function HeroSection({ onCTAClick }: HeroSectionProps) {
  return (
    <section 
      className="relative min-h-screen bg-cover bg-center bg-no-repeat flex items-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/42a8e083bf3f33e8908b066853de542a.jpg')`
      }}
    >
      {/* Logos Uber Eats, Deliveroo et Just Eat en haut à droite - optimisé mobile */}
      <div className="absolute top-4 right-4 md:top-6 md:right-6 z-10">
        <div className="flex gap-2 md:gap-3 items-center">
          <img 
            src="https://static.readdy.ai/image/a343775702a04f57d19e2d80438d20f8/5bf130391ed6bd3111354f4f2ad640e2.png"
            alt="Uber Eats"
            className="w-12 h-8 md:w-20 md:h-12 object-contain"
          />
          <img 
            src="https://static.readdy.ai/image/a343775702a04f57d19e2d80438d20f8/35956f4f4d3d7d170ad0681dfb720bcf.png"
            alt="Deliveroo"
            className="w-12 h-8 md:w-20 md:h-12 object-contain"
          />
          <div className="h-8 md:h-12 flex items-center">
            <span className="text-sm md:text-xl font-bold text-orange-500">Just Eat</span>
          </div>
        </div>
      </div>

      {/* Badge de rareté repositionné pour mobile */}
      <div className="absolute top-20 md:top-6 left-4 md:left-6 right-4 md:right-auto z-10">
        <div className="bg-red-600 text-white px-3 py-2 md:px-4 md:py-2 rounded-full font-bold text-xs md:text-sm flex items-center justify-center animate-pulse shadow-lg mx-auto md:mx-0 max-w-xs md:max-w-none">
          <i className="ri-alert-line mr-1 md:mr-2"></i>
          <span className="text-center">⚡ Attention : nous ne travaillons qu'avec 3 nouveaux restaurants par mois</span>
        </div>
      </div>

      <div className="container mx-auto px-4 py-20 mt-16 md:mt-0">
        <div className="max-w-4xl mx-auto">
          <div className="bg-black/60 backdrop-blur-sm p-6 md:p-8 rounded-2xl text-center md:text-left">
            <h1 className="text-2xl md:text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Nous créons vos <span className="text-[#9EFD38]">ventes</span>.
              <br />
              Vous, vous ne <span className="text-[#9EFD38]">changez rien</span>.
            </h1>
            
            <p className="text-lg md:text-xl lg:text-2xl text-gray-200 mb-8 leading-relaxed">
              VirtualEat crée vos marques virtuelles et génère des ventes chaque jour… 
              que vous soyez déjà sur les plateformes de livraison ou pas,
              <strong className="text-white"> sans changer votre cuisine !</strong>
            </p>
            
            <div className="flex flex-col items-center md:items-start gap-4">
              <button 
                onClick={onCTAClick}
                className="bg-[#9EFD38] hover:bg-[#8AE832] text-black font-bold text-sm md:text-lg px-4 md:px-8 py-2 md:py-4 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer text-center w-full max-w-[280px] md:max-w-none"
              >
                <i className="ri-arrow-down-line mr-1 md:mr-2"></i>
                <span className="text-xs md:text-base">Réserver mon appel gratuit</span>
              </button>
              
              <div className="flex items-center justify-center md:justify-start gap-2 text-white">
                <i className="ri-shield-check-line text-[#9EFD38] text-xl"></i>
                <span className="text-sm">100% gratuit • Aucun engagement</span>
              </div>
            </div>

            {/* Badge supplémentaire dans le hero - centré sur mobile */}
            <div className="mt-6 flex flex-col md:flex-row items-center justify-center md:justify-start gap-3">
              <div className="bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm flex items-center">
                <i className="ri-money-euro-circle-line text-[#9EFD38] mr-2"></i>
                0€ d'investissement
              </div>
              <div className="bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm flex items-center">
                <i className="ri-time-line text-[#9EFD38] mr-2"></i>
                Résultats en 30 jours
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}
